export const emptyStringToNull = (value: string, originalValue: string) =>
  typeof originalValue === 'string' && originalValue.trim() === ''
    ? null
    : value;
